'use client';
import { FC, PropsWithChildren, useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';

export interface PortalProps {
  id: string;
}
// Copied from Next.js Examples https://github.com/vercel/next.js/blob/canary/examples/with-portals/components/ClientOnlyPortal.js
export const Portal: FC<PropsWithChildren<PortalProps>> = ({
  children,
  id
}) => {
  const [mounted, setMounted] = useState(false);
  const portalRoot = useRef<null | HTMLElement>(null);

  useEffect(() => {
    portalRoot.current = document.getElementById(id);
    setMounted(true);
  }, [id]);

  return mounted && portalRoot.current
    ? createPortal(children, portalRoot.current)
    : null;
};
